module.exports = __webpack_public_path__ + "static/img/malicious_actor_1.c6088853.svg";